import { Button, Icon } from 'components/common';
import { useDispatch } from 'react-redux';
import { setShowNLPFilterModal } from 'actions/searchNLP';
import styled from 'styled-components';
import { colours } from 'utils/theme';
import { BetaBadge } from './styled';
import { aiSearchProductName } from 'utils/constants';

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  transition: color 0.15s ease, transform 0.15s ease;
  color: ${colours.black};
`;

const StyledButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 6px;
  font-size: ${p => (p.size === 'large' ? '16px' : 'inherit')};
  &:hover ${IconWrapper} {
    transform: scale(1.1) rotate(-3deg);
    color: ${colours.blue};
  }
`;

// size/style let the org-profile search bars (default-size buttons, spaced by
// margin rather than flex gap) render this button flush with their neighbours.
// disabled/tooltip let callers grey the button out with an explanation, e.g.
// on organisations with no people or activities to search (SCIL-17613).
export const NLPSearchOpenButton = ({
  loading,
  size = 'large',
  style,
  disabled = false,
  tooltip,
}) => {
  const dispatch = useDispatch();
  const handleShowNLPModal = () => {
    dispatch(setShowNLPFilterModal(true));
  };

  return (
    <StyledButton
      data-testid='nlp-filter-button'
      type='secondary'
      size={size}
      style={style}
      tooltip={tooltip}
      onClick={handleShowNLPModal}
      disabled={loading || disabled}
    >
      <IconWrapper>
        <Icon icon='sparkles' color={null} size='sm' />
      </IconWrapper>
      <span>{aiSearchProductName}</span>
      <BetaBadge>Beta</BetaBadge>
    </StyledButton>
  );
};
